<h2 class="pb-s">Vorsicht vor Feedback? Auf keinen Fall!</h2>
<p>
  Als Beauftragte*r haben Sie die Möglichkeit, gezielt <strong>Feedback stellvertretend für Ihre Apotheke zu platzieren</strong> und als <strong>Sparringspartner für Ihr eigenes Team</strong> zu agieren. So können Sie Ihre Kolleginnen und Kollegen unterstützen, indem Sie Ihr Know-How mit ihnen teilen und zusammen den <strong>Erfolg Ihrer Apotheke steigern</strong>.
</p>
<p>
  Teilen Sie uns mit, <strong>was Ihnen auf dem Herzen liegt</strong> und fühlen Sie sich völlig frei, ob Sie uns zu den aufgeführten oder anderen Themen Ihr Feedback geben. Wir freuen uns, wenn Sie sich dafür einen Augenblick Zeit nehmen, denn nur so können wir Ihre Anregungen und Wünsche berücksichtigen und unsere <strong>Kooperation gemeinsam mit Ihnen gestalten</strong>.
</p>

<span>
  Mögliche Themen können sein:
</span>
<ul>
  <li>PHOENIX Kooperations-Partnerschaft (PKP)</li>
  <li>Marketingmaterialien</li>
  <li>be healthy!</li>
  <li>Mein Ratgeber Diabetes</li>
  <li>Warenzuteilung</li>
  <li>Rechnungsstellung</li>
  <li>Sonstiges</li>
</ul>
<form class="row">
<div class="col-md-12">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label style="white-space: pre" class="textarea-label">Ihre Wünsche, Anregungen und Ihr Feedback</mat-label>
    <textarea matInput
              readonly></textarea>
  </mat-form-field>
  <button class="btn-primary on-dark-bg mr-l">
    Absenden
  </button>
</div>
</form>
